import DsaInterviewVoicePage from "./DsaInterviewVoicePage";

export default DsaInterviewVoicePage;
